import type { IconName } from '@hotjar/hotsauce';
import type { Experiment } from '../../../../domains/experiments/model/Experiment';
import { GenericFilter } from '../GenericBloc/GenericFilter/GenericFilter';
import type { AbstractSingleFilterPillsProps } from '../SingleFilterType';
import { ExperimentDropdown } from './ExperimentDropdown';
import type { ExperimentType } from './ExperimentFilterType';

interface ExperimentFilterProps extends AbstractSingleFilterPillsProps<ExperimentType> {
  filterName: string;
  iconName: IconName;
  optionList?: Experiment[];
  optionListIsLoading: boolean;
  label1?: string;
  label2?: string;
  isIntegrationActive: boolean;
}

export function ExperimentFilter({
  currentValue,
  autoFocus,
  filterName,
  iconName,
  onApply,
  onRemove,
  onDropdownHidden,
  showDropdownOnMount,
  optionList = [],
  optionListIsLoading,
  onDropdownShown,
  label1,
  label2,
  isIntegrationActive,
}: ExperimentFilterProps): JSX.Element {
  const handleApply = (close: () => void, newValue?: ExperimentType) => {
    onApply(newValue);
    close();
  };

  return (
    <GenericFilter
      filterName={filterName}
      label1={label1}
      label2={label2}
      autoFocus={autoFocus}
      iconName={iconName}
      onRemove={onRemove}
      showDropdownOnMount={showDropdownOnMount}
      onDropdownHidden={onDropdownHidden}
      onDropdownShown={onDropdownShown}
      renderDropdown={({ close }) => {
        return (
          <ExperimentDropdown
            filterName={filterName}
            currentValue={currentValue}
            onApply={(newValue) => handleApply(close, newValue)}
            optionList={optionList}
            optionListIsLoading={optionListIsLoading}
            isIntegrationActive={isIntegrationActive}
          />
        );
      }}
    />
  );
}
